import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

export interface MainTestFormWrapperProps {
    formId: string;
    children: React.ReactNode;
    scrollAreaRef?: React.RefObject<HTMLDivElement>;
    className?: string;
}

export function MainTestFormWrapper({ formId, children, scrollAreaRef, className }: MainTestFormWrapperProps) {
    return (
        <div className={cn("h-full overflow-hidden", className)}>
            {/* type="always": the popup's only hint that content below the fold
                (e.g. a wrapped 3rd row of reference images) still exists is this
                scrollbar — the default "hover" track doesn't mount until the
                pointer enters the area, so it read as content being dropped
                entirely (QA 1.02). */}
            <ScrollArea className="h-full" type="always" ref={scrollAreaRef}>
                {children}
            </ScrollArea>
        </div>
    )
}